enum ButtonTypes {
    Submit = 'submit',
    Reset = 'reset',
    Button = 'button'
}

export default ButtonTypes;